var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 6.5C13.2761 6.5 13.5 6.72386 13.5 7V13C13.5 13.2761 13.2761 13.5 13 13.5H1C0.723858 13.5 0.5 13.2761 0.5 13V7.00277C0.5 6.72662 0.723858 6.50277 1 6.50277C1.27614 6.50277 1.5 6.72662 1.5 7.00277V12.5H12.5V7C12.5 6.72386 12.7239 6.5 13 6.5Z",
    fill: "#524986"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.64645 0.646447C6.84171 0.451184 7.15829 0.451184 7.35355 0.646447L10.3536 3.64645C10.5488 3.84171 10.5488 4.15829 10.3536 4.35355C10.1583 4.54882 9.84171 4.54882 9.64645 4.35355L7 1.70711L4.35355 4.35355C4.15829 4.54882 3.84171 4.54882 3.64645 4.35355C3.45118 4.15829 3.45118 3.84171 3.64645 3.64645L6.64645 0.646447Z",
    fill: "#524986"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99723 0.5C7.27338 0.5 7.49723 0.723858 7.49723 1V9.66667C7.49723 9.94281 7.27338 10.1667 6.99723 10.1667C6.72109 10.1667 6.49723 9.94281 6.49723 9.66667V1C6.49723 0.723858 6.72109 0.5 6.99723 0.5Z",
    fill: "#524986"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadNew);
export default __webpack_public_path__ + "static/media/upload-new.f6e3696c.svg";
export { ForwardRef as ReactComponent };